import React from 'react';
import CTAButton from '../ctaButton/CTAButton';
import PropTypes from 'prop-types';

const CTABanner = (props) => {
  const { src, callToAction, backgroundImage } = props;

  let backgroundStyle = `linear-gradient(rgba(26,35,67,0.65), rgba(26,35,67,0.65))`;
  backgroundStyle += backgroundImage ? `, url(${backgroundImage})` : '';

  return (
    <section className="cta-section" style={{ backgroundImage: backgroundStyle }}>
      <div className="cta-section__inner">
        <div className="cta-section-text" dangerouslySetInnerHTML={{ __html: props[src] }} />
        <CTAButton {...callToAction} />
      </div>
    </section>
  );
};

CTABanner.propTypes = {
  src: PropTypes.string,
  callToAction: PropTypes.shape(CTAButton.propTypes),
  backgroundImage: PropTypes.string
};

export default CTABanner;
